export { default as SenderImage } from './components/SenderImage';
export { default as SenderImageWrapper } from './components/SenderImageWrapper';
export { default as SenderPersona } from './components/SenderPersona';
export { default as SenderPersonaWrapper } from './components/SenderPersonaWrapper';
export { default as MeetingForwardSenderPersona } from './components/MeetingForwardSenderPersona';
